import React, { Component } from 'react';

class _404 extends Component {
    constructor () {
        super();
        this.fireRedirect = this.fireRedirect.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }
    
    componentDidMount () {
    }
    
    handleRedirect(url) {
        this.props.history.push(url);
    }
    
    fireRedirect(e) {
        e.preventDefault()
        this.handleRedirect(e.currentTarget.getAttribute('href'));
    }
    
    render () {
        return (
            <div className="wrapper">
                <div id="content">
                    <main>
                        <div className="position-absolute h-100 w-100 m-0 d-flex align-items-center justify-content-center">
                            <div className="mx-auto" id="login_container">
                                <div className="card p-5">
                                    <div className="card-body">
                                        <h3 className="text-center">システムエラー</h3>
                                        <figure className="mb-5 text-center">
                                            <img src="/img/500.png" height="120" />
                                        </figure>
                                        <p>
                                            500はCGIの設定やプログラムのミスが<br />
                                            あった場合などに返されるコードです。<br />
                                            このエラーの場合、設定が間違っている場合が<br />
                                            多いので、パーミッションやコードの修正が必要です。
                                        </p>
                                        <a href="/houjin/home" className="btn btn-warning btn-lg btn-block">ダッシュボードへ戻る</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}
export default _404;